
import React, { Fragment } from 'react';

export const cleanEmbed = (string) => {
  return stripStyleTags(string)
}

export const addSkipActiveDemand = (string) => {
  return string ? string.replace("class='ad-form-check activedemand'", "class='ad-form-check activedemand skip-activedemand-css'") : "";
}

export const stripScriptTags = (string) => {
  return string ? string.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "") : "";
}

export const stripStyleTags = (string) => {
  return string ? string.replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, "") : "";
}

export const stripStyleAttributes = (string) => {
  return string ? string.replace(/style='(.*?)' /gi, "").replace(/style="(.*?)" /gi, "") : "";
}

export const hyphenToParagraph = (text?: string | null) => {
  if (text) {
    return text.split(' - ').map((paragraph, index) => (
      <p key={index} >
        {paragraph}
      </p>
    ));
  }

  return undefined;
};

export const colonToSpan = (text?: string | null) => {
  if (text) {
    return text.split(/(?<=:)/).map((paragraph, index) => (
      <span key={index} >
        {paragraph.trim()}
      </span>
    ));
  }

  return undefined;
};

export const plainTextToHTML = (text?: string | null) => {
  if (text) {
    return text.split('\n\n').map((paragraph: string, index: number) => (
      <p key={index} >
        {
          paragraph
            .split('\n')
            .map((line: string, lineIndex: number, array: Array<string>) => (
              <Fragment key={lineIndex} >
                {line}
                {
                  lineIndex < array.length - 1 && <br />}
              </Fragment>
            ))
        }
      </p>
    ));
  }

  return undefined;
};